import React from 'react'
import { Container, Button, Row, Col, Input } from 'reactstrap';
import * as XLSX from "xlsx";
import 'bootstrap/dist/css/bootstrap.css';

//const testData = require('./TestData.js');

class ImportTimeRevWorksheet extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            importData: [],
            readSuccess: [],
            uploadSuccess: false,
            saveSuccess: false
        };

    }

    componentDidMount = () => {
        this.props.log('ImportTimeRevWorksheet.js/componentDidMount');
    }

    parseDate = (date) => {
        const d = new Date(date);
        return d.getFullYear() + '-' + ('0' + parseInt(d.getMonth() + 1)).slice(-2) + '-01';
    }

    handleUpload = (e, schema) => {
        this.props.log('ImportTimeRevWorksheet.js/handleUpload (e,schema) ', e, schema);
        e.preventDefault();
        var files = e.target.files, f = files[0];
        var reader = new FileReader();
        reader.onload = (r) => {
            var result = r.target.result;
            let readedData = XLSX.read(result, { type: 'binary', cellDates: true, sheetStubs: true });
            let dataArr = [];
            const ws = readedData.Sheets[readedData.SheetNames[0]];
            let data = XLSX.utils.sheet_to_json(ws, { header: 1 });
            const numColumns = Math.max(...data.map(el => el.length));
            if (data.length === 0) return;
            data.forEach((row, index, arr) => {
                if (row[0] === 'company number' || row[4] === '') {

                } else {
                    if (row[0] != null && row[0] !== '') {
                        let dataRow = {
                            customerNumber: row[0],
                            accountNumber: String(row[1]),
                            customer: (row[2] != null && row[2] !== '' ? row[2] : ''),
                            id: (data[index + 1][2] != null && data[index + 1][2] !== '' ? data[index + 1][2] : '') +
                                (data[index + 2][2] != null && data[index + 2][2] !== '' ? (' ' + data[index + 2][2]) : ''),
                            hours: [],
                            billed: []
                        };
                        for (let i = 4; i < numColumns; i++) {
                            if (row[i] != null) dataRow.hours.push({ date: this.parseDate(data[0][i]), value: row[i] })
                            if (data[index + 1][i] != null) dataRow.billed.push({ date: this.parseDate(data[0][i]), value: data[index + 1][i] })
                        }
                        dataArr.push(dataRow);
                    }
                }
            })
            dataArr.sort((a,b) => a.accountNumber.localeCompare(b.accountNumber));
            dataArr.sort((a,b) => a.customerNumber - b.customerNumber);
            this.setState({
                readSuccess: true,
                uploadSuccess: false,
                saveSuccess: false,
                importData: dataArr,
            });
        };
        if (f instanceof Blob || typeof (f) === 'object') {
            reader.readAsBinaryString(f)
        } else {
            this.setState({
                readSuccess: false,
                uploadSuccess: false,
                saveSuccess: false,
                importData: [],
            })
        }

    }

    handleSave = () => {
        this.props.log('ImportTimeRevWorksheet.js/handleSave');
        // return;
        // const json_request = JSON.stringify({
        //     data: this.state.importData
        // });
        // fetch('/api/customerRevenue/', {
        //     method: 'POST',
        //     body: json_request,
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': 'Bearer ' + this.props.clientToken
        //     }
        // }).then(results => results.json())
        //     .then(results => {
        //         results.success ?
        //             this.setState({
        //                 uploadSuccess: true,
        //                 saveSuccess: true,
        //                 importData: []
        //             }, () => {this.getCustomerRevenue(); this.props.addToast('Customer revenue data imported successfully.', 5, 'success'); }) :
        //             this.setState({
        //                 uploadSuccess: true,
        //                 saveSuccess: false,
        //             }, () => this.props.addToast('Unable to import customer revenue data.', 5, 'danger'))
        //     })
        //     .catch(() => {
        //         this.props.addToast('An error has occurred.', 5, 'danger');
        //     })
    };

    render = () => {
        this.props.info('ImportTimeRevWorksheet.js/render');
        return (
            <>
                <Container>
                    <Row>
                        <Col md={6}>
                            <Row className="p-2">
                                <Col md={12} className="text-left">
                                    <Input type="file" name={"file_"} id="file" accept='.xlsx' onChange={e => this.handleUpload(e)} />
                                </Col>
                            </Row>
                            <Row className="p-2">
                                <Col md={12} className="text-left">
                                    <Button color="success" disabled={this.state.importData.length === 0} onClick={this.handleSave} title="Upload">Upload</Button>
                                </Col>
                            </Row>
                        </Col>
                        {(this.state.importData.length > 0) ?
                            <Col md={6}>
                                <Row className="p-2">
                                    <Col md={12}>
                                        {this.state.importData.length} records ready to upload
                                    </Col>
                                </Row>
                            </Col> : <></>}
                    </Row>
                </Container>
            </>
        )
    }
}

export default ImportTimeRevWorksheet;